import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

const logo = ['versus-br', 'versus-mx'].includes(CLIENT_NAME) ? 'logo-br' : 'logo';

export function getPageHeadersConfigs() {
    return {
        custom: {
            [PALETTE_IDS.INTERFACE]: {
                ApplicationMenu: {
                    logo: {
                        style: {
                            height: 32,
                            width: 155,
                        },
                        src: `generic/${logo}.svg`,
                    },
                    logoButton: {
                        style: {
                            base: {
                                flexBasis: 155,
                            },
                        },
                    },
                },
            },
            [PALETTE_IDS.BET_SHARING_DIALOG]: {
                ShareBetContent: {
                    logo: {
                        src: `generic/${logo}.svg`,
                    },
                },
                ShareBetslip: {
                    logo: {
                        src: `generic/${logo}.svg`,
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.APPLICATION_HEADER]: {
                APPLICATION_HEADER_BG: COLOR.BRAND.BACKGROUND7,
                APPLICATION_HEADER_LOGIN_BUTTON: {
                    SECONDARY_BUTTON_SELECTED_BG: '#dbff00',
                    SECONDARY_BUTTON_BORDER_COLOR: '#dbff00',
                    SECONDARY_BUTTON_TEXT: '#dbff00',
                },
                APPLICATION_HEADER_SIGNUP_BUTTON: {
                    PRIMARY_BUTTON_BG: '#dbff00',
                    PRIMARY_BUTTON_SELECTED_BG: '#dbff00',
                },

                APPLICATION_HEADER_USER_INFO_NAME_TEXT: {
                    color: COLOR.RESERVED.WHITE,
                    fontStretch: 'normal',
                    fontSize: 11, // according to design
                },
                APPLICATION_HEADER_USER_INFO_BALANCE_TEXT: {
                    color: COLOR.RESERVED.WHITE,
                    fontStretch: 'normal',
                    fontSize: FONT.SIZE_MEDIUM,
                },

                APPLICATION_HEADER_NAV_BAR_BG: COLOR.BRAND.BACKGROUND6,
                APPLICATION_HEADER_NAV_BAR_PAGE_SELECTOR: {
                    PIVOT_TEXT: {
                        color: COLOR.BRAND.BACKGROUND1,
                        whiteSpace: 'nowrap',
                    },
                },

                APPLICATION_HEADER_NAV_BAR_SESSION_TIME_LABEL_TEXT: {
                    fontSize: 9,
                    color: COLOR.BRAND.BACKGROUND1,
                },
                APPLICATION_HEADER_NAV_BAR_SESSION_TIME_VALUE_TEXT: {
                    fontSize: 11,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.BACKGROUND1,
                },
                APPLICATION_HEADER_NAV_BAR_SEARCH_INPUT: {
                    INPUT_BORDER_RADIUS: 20,
                    INPUT_PLACEHOLDER_TEXT: COLOR.BRAND.FOREGROUND6,
                    INPUT_ICON_COLOR: COLOR.BRAND.FOREGROUND6,
                    INPUT_BORDER_COLOR: COLOR.BRAND.FOREGROUND6,
                    INPUT_BG: COLOR.RESERVED.TRANSPARENT,
                    INPUT_TEXT: COLOR.BRAND.FOREGROUND6,
                },
                SEARCH_POPOVER: {
                    POPOVER_BG: COLOR.BRAND.BACKGROUND1,
                    POPOVER_TEXT: COLOR.BRAND.BACKGROUND6,
                    POPOVER_BORDER_RADIUS: 0,
                },
            },
            [PALETTE_IDS.INTERFACE]: {
                BANNER_BG: COLOR.BASE.PAGE,
                SYSTEM_INITIALIZATION_TITLE_TEXT: COLOR.BRAND.FOREGROUND6,
            },
            [PALETTE_IDS.BREADCRUMBS]: {
                BREADCRUMBS_BACK_BUTTON_ICON_COLOR: COLOR.BRAND.CTA2,
                BREADCRUMBS_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND4}`,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                BREADCRUMBS_QUICK_NAVIGATION_CATEGORY_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND4}`,
                BREADCRUMBS_QUICK_NAVIGATION_TOURNAMENT_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND4}`,
                BREADCRUMBS_QUICK_NAVIGATION_ICON_COLOR: COLOR.BRAND.CTA2,

                MOBILE_BREADCRUMBS_BACK_BUTTON_ICON_COLOR: COLOR.BRAND.ACCENT1,
                MOBILE_BREADCRUMBS_QUICK_NAVIGATION_ICON_COLOR: COLOR.BRAND.ACCENT1,

                EVENT_NOTIFICATION_SUBSCRIBER_POPOVER: {
                    POPOVER_TEXT: {
                        color: COLOR.BRAND.BACKGROUND6,
                        fontSize: FONT.SIZE_MEDIUM,
                    },
                },
            },
            [PALETTE_IDS.SETTINGS]: {
                SETTINGS_SECTION_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                SETTINGS_ITEM_EXPAND_ICON: COLOR.BRAND.ACCENT3,
                SETTINGS_TIMEZONE_BUTTON: {
                    TOGGLE_BUTTON_BORDER_RADIUS: 0,
                },
                SETTINGS_ODDS_FORMAT_SELECTOR: {
                    LIST_ITEM_SELECTED_BG: COLOR.BRAND.ACCENT1,
                },
                SETTINGS_LANGUAGE_SELECTOR: {
                    LIST_ITEM_SELECTED_BG: COLOR.BRAND.ACCENT1,
                },
            },
        },
    };
}
